import { render, staticRenderFns } from "./longOrder.vue?vue&type=template&id=829aa56e&scoped=true&"
import script from "./longOrder.js?vue&type=script&lang=js&"
export * from "./longOrder.js?vue&type=script&lang=js&"
import style0 from "./longOrder.vue?vue&type=style&index=0&id=829aa56e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829aa56e",
  null
  
)

export default component.exports